var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allPage"},[_c('div',{staticClass:"packageL"},[_c('topPage',{ref:"topPageRef",on:{"cutUrl":_vm.cutUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }